import React, { Component } from 'react'
import InvoiceModal from '../../../components/Common/InvoiceModal/InvoiceModal'
import { pick } from 'lodash'
import { message } from 'antd'
import Invoices from '../../../api/Sales/Invoices'
import { normalizeDateTimeToDate, numVal } from '../../../modules/Utils'
import moment from 'moment'
import { round } from 'lodash'

class InvoiceModalCont extends Component {
  calculateSum = (line, invoiced) => {
    let nt = round(invoiced * line.rate, 2)
    let tx = round((nt * numVal(line, 'tax.percentage')) / 100, 2)
    const gross = round(tx + nt, 2)
    const amount = { net: nt, tax: tx, gross }
    return { ...line, invoiced, amount }
  }
  state = {
    billLines: [...this.props.billLines]
      .map((b) => {
        //b.unit -= numVal(b, 'invoiced') < 0 ? 0 : numVal(b, 'invoiced')
        const invoiced = b.unit - numVal(b, 'invoiced')
        return { ...this.calculateSum(b, invoiced), percentage: 100 }
      })
      .filter((b) => b.invoiced !== 0),
    order: this.props.order || {},
    orderType: this.props.orderType,
    keyAttr: '_key',
    invoice: {},
  }
  api = new Invoices()
  invoiceFormRef = React.createRef()
  invoiceBooking = async () => {
    const values = await this.checkForm()
    let { billLines } = this.state
    billLines = billLines
      .filter((b) => b.invoiced !== 0)
      .map((b) => {
        b.unit = b.invoiced
        b.invoicing = {
          periodFrom: normalizeDateTimeToDate(values, 'period.0', true),
          periodTo: normalizeDateTimeToDate(values, 'period.1', true),
          date: normalizeDateTimeToDate({ value: moment() }, 'value', true),
        }
        return pick(b, ['unit', 'invoicing', 'percentage', '_id', '_rev'])
      })
    if (billLines.length < 1) {
      message.error('No Bookings Found')
      return
    }
    try {
      this.setState({
        invoicing: true,
      })
      let data = {}
      if (this.props.type === 'combo') {
        data = await this.api.combo({ lines: billLines })
      } else {
        data = await this.api.manual({
          _id: this.state.order._id,
          date: normalizeDateTimeToDate({ value: moment() }, 'value', true),
          final: values.final,
          lines: billLines,
        })
      }
      this.setState({
        invoicing: false,
      })
      message.success(
        <span>
          Invoice has been created. Click{' '}
          <a href={`#/clients/invoices/${data.invoiceDB._key}/view`} target={'_blank'}>
            {' '}
            here
          </a>{' '}
          to view{' '}
        </span>
      )
      this.props.onCancelInvoice()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({ invoicing: false })
    }
  }
  onChangeInvoicePercentage = (percentage) => {
    this.setState((prvState) => {
      return {
        billLines: prvState.billLines.map((b) => {
          const invoiced = Math.round(b.unit * (percentage / 100) * 100) / 100
          return { ...this.calculateSum(b, invoiced), percentage }
        }),
      }
    })
  }

  cancel = (_key) => {
    const { billLines } = this.state
    const newData = [...billLines]
    const target = newData.find((item) => _key === item[this.state.keyAttr])
    if (target) {
      delete target.editable
      if (Object.keys(target).length === 1 && Object.keys(target)[0] === [this.state.keyAttr])
        this.remove(target[this.state.keyAttr])
      else
        this.setState({
          billLines: newData,
        })
    }
  }
  remove = (_key) => {
    const { billLines } = this.state
    let newData = [...billLines]
    newData = newData.filter((item) => _key !== item[this.state.keyAttr])
    this.setState({
      billLines: newData,
    })
  }
  edit = (_key) => {
    const { billLines } = this.state
    let newData = [...billLines]
    const target = newData.find((item) => _key === item[this.state.keyAttr])
    if (target) {
      target.editable = true
      this.setState({
        billLines: newData,
      })
    }
  }
  save = (_key) => {
    const { billLines } = this.state
    let newData = [...billLines]
    let target = newData.find((item) => _key === item[this.state.keyAttr])
    if (target) {
      delete target.editable
      delete target.percentage
      this.setState({
        billLines: newData,
      })
    }
  }
  handleChange = (value, _key, column) => {
    const { billLines } = this.state
    let newData = [...billLines]
    let target = newData.find((item) => _key === item[this.state.keyAttr])
    if (target) {
      target[column] = value
      let { amount } = this.calculateSum(target, target.invoiced)
      target['amount'] = amount
      this.setState({
        billLines: newData,
      })
    }
  }
  checkForm = () => {
    return new Promise((res, rej) => {
      this.invoiceFormRef.current.validateFields((err, values) => {
        if (!err) {
          res(values)
        }
      })
    })
  }
  render() {
    return (
      <InvoiceModal
        {...this.props}
        {...this.state}
        {...pick(this, [
          'invoiceBooking',
          'cancel',
          'remove',
          'edit',
          'save',
          'handleChange',
          'onChangeInvoicePercentage',
          'invoiceFormRef',
        ])}
      />
    )
  }
}

InvoiceModalCont.propTypes = {}
InvoiceModalCont.defaultProps = { billLines: [] }

export default InvoiceModalCont
